export const FiltersConfig = [
    {
        span: 6,
        height: "40px",
        classes: "marginTop-8",
        columns: [
            {
                span: 5,
                height: "40px",
                rows: [
                    {
                        span: 5,
                        height: "40px",
                    },
                ],
            },
        ],
    },
    {
        span: 6,
        height: "194px",
        classes: "marginTop-8",
        columns: [
            {
                span: 5,
                height: "186px",
                rows: [
                    {
                        span: 3,
                        height: "60px",
                        classes: "marginTop-8",
                    },
                    {
                        span: 5,
                        height: "60px",
                        classes: "marginTop-8",
                    },
                    {
                        span: 5,
                        height: "60px",
                        classes: "marginTop-4",
                    },
                    {
                        span: 5,
                        height: "60px",
                        classes: "marginTop-4",
                    },
                ],
            },
        ],
    },
    {
        span: 5,
        height: "350px",
        classes: "marginTop-8",
        columns: [
            {
                span: 4,
                height: "300px",
                rows: [
                    {
                        span: 3,
                        height: "55px",
                        classes: "marginTop-4",
                    },
                    {
                        span: 5,
                        height: "56px",
                        classes: "marginTop-8",
                    },
                    {
                        span: 5,
                        height: "57px",
                        classes: "marginTop-4",
                    },
                    {
                        span: 5,
                        height: "60px",
                        classes: "marginTop-4",
                    },
                    {
                        span: 5,
                        height: "60px",
                        classes: "marginTop-4",
                    },
                    {
                        span: 5,
                        height: "60px",
                        classes: "marginTop-4",
                    },
                    {
                        span: 5,
                        height: "60px",
                        classes: "marginTop-4",
                    },
                ],
            },
        ],
    },
]
